import React, { memo, useState } from 'react';
import { get } from 'lodash';
import { SelectTransactionButton } from 'components';
import { Button, Modal, Icon } from 'components';
import { useModal, useAction, useSelect } from 'hooks';
// import ContainerServiceOptions from './ContainerServiceOptions';
import ContainerSelectedServiceInitialForm from './ContainerSelectedServiceInitialForm';
import { useHistory, Route } from 'react-router-dom';


const ContainerSelectTransaction = memo(() => {
  const [isPassed, setIsPassed] = useState(false)
  const history = useHistory()
  // const [isOpenServiceOptionModal, onOpenServiceOptionModal, onCloseServiceOptionModal] = useModal()
  const [isOpenSelectedServiceModal, onOpenSelectedServiceModal, onCloseSelectedServiceModal] = useModal()
  const selectedTransaction = useSelect('transaction.selected')

  const getSelectedService = useAction('transaction.show');

  const handleselectService = e => {
    e.preventDefault()
    onOpenSelectedServiceModal()
    getSelectedService(get(selectedTransaction, 'id'))
  }

  const hadleProceed = e => {
    e.preventDefault()
    onCloseSelectedServiceModal()
    history.push('/application-form')
  }

  return (
    <>
      <Route exact path="/" render={() => (
        <SelectTransactionButton 
          onClick={handleselectService}
        />
      )}/>
      {/* <Modal isOpen={isOpenServiceOptionModal} onClose={onCloseServiceOptionModal}>
        <ContainerServiceOptions onSelect={handleselectService}/>
        <div className="footer space-x-2">
          <button type="button" className="btn btn-warning !w-auto" onClick={() => onCloseServiceOptionModal()}>Close</button>
        </div>
      </Modal> */}
      <Modal isOpen={isOpenSelectedServiceModal} onClose={onCloseSelectedServiceModal}>
        <div className="flex -mt-24">
          <div className="m-auto flex bg-white rounded-full w-40 h-40">
            <Icon.CPC className="m-auto"/>
          </div>
        </div>
        {/* <Button 
          type="button" 
          onClick={() => {
            onCloseSelectedServiceModal()
            onOpenServiceOptionModal()
          }} 
          className="!bg-warning !w-auto !text-black">
            <Icon.ArrowLeft />
            <span>Back</span>
        </Button> */}
        <ContainerSelectedServiceInitialForm onChangeIsPassed={setIsPassed}/>
        <div className="footer space-x-2">
          <Button disabled={!isPassed} onClick={hadleProceed} className="!bg-warning !text-black"><span>Proceed</span></Button>
        </div>
      </Modal>
    </>
  )
})

export default ContainerSelectTransaction;